import { SVGProps } from "react";

const DoneIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_885_5298)">
        <path
          d="M10.7507 20.6527C16.0894 20.6527 20.4173 16.3248 20.4173 10.986C20.4173 5.64725 16.0894 1.31934 10.7507 1.31934C5.4119 1.31934 1.08398 5.64725 1.08398 10.986C1.08398 16.3248 5.4119 20.6527 10.7507 20.6527Z"
          fill="#5EDD60"
        />
        <path
          d="M8.83762 15.0094L6.57095 12.7954C6.52193 12.7478 6.48295 12.6908 6.45634 12.6278C6.42973 12.5648 6.41602 12.4971 6.41602 12.4288C6.41602 12.3604 6.42973 12.2927 6.45634 12.2297C6.48295 12.1668 6.52193 12.1098 6.57095 12.0621L7.32262 11.3288C7.42342 11.2311 7.55827 11.1765 7.69862 11.1765C7.83897 11.1765 7.97382 11.2311 8.07462 11.3288L9.42395 12.6478L13.2083 6.89444C13.2864 6.77834 13.4065 6.69716 13.5434 6.66805C13.6802 6.63894 13.823 6.66418 13.9416 6.73844L14.8363 7.30044C14.8947 7.33637 14.9453 7.38367 14.9852 7.43954C15.025 7.4954 15.0532 7.55869 15.068 7.62565C15.0829 7.69262 15.0842 7.76189 15.0718 7.82936C15.0595 7.89683 15.0337 7.96113 14.996 8.01844L10.515 14.8331C10.4252 14.9665 10.3072 15.0786 10.1694 15.1615C10.0316 15.2443 9.87736 15.296 9.71745 15.3128C9.55754 15.3296 9.39588 15.3112 9.24387 15.2588C9.09186 15.2063 8.95319 15.1212 8.83762 15.0094Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_885_5298">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.75 0.986328)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DoneIcon;
